import { useMemo } from 'react';
import { defineColumn } from '../../../components/tanstack-table/column';
import { TanStackTable } from '../../../components/tanstack-table/table';
import type { UnknownProduct } from '../../../data/receiving';
import { emDashIfEmpty, productHeadColumns } from './product-columns';

export function DuplicateItemCodesTable({
  rows,
  vendorNames,
}: {
  rows: UnknownProduct[];
  vendorNames?: Map<string, string>;
}) {
  const columns = useMemo(() => {
    const showVendor = (vendorNames?.size ?? 0) > 1;

    return [
      ...productHeadColumns<UnknownProduct>((p) => p),
      defineColumn<UnknownProduct>({
        id: 'Item code',
        minWidth: 100,
        maxWidth: 160,
        accessorFn: (p) => emDashIfEmpty(p.item_code || p.raw_item_code),
        cell: ({ value }) => <span className="font-mono">{value}</span>,
      }),
      defineColumn<UnknownProduct>({
        id: 'Also used by',
        minWidth: 280,
        maxWidth: 520,
        accessorFn: (p) =>
          p.conflicts
            .map((c) => {
              const label = [c.brand, c.description, c.size].filter(Boolean).join(' ');
              const vendor = showVendor ? vendorNames?.get(c.vendor_id) : undefined;

              return vendor ? `${label} (${vendor})` : label;
            })
            .join('; '),
      }),
    ];
  }, [vendorNames]);

  return <TanStackTable data={rows} columns={columns} />;
}
